import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);


import Dashboard from '../pages/Dashboard';
import Modules from '../pages/modules/Modules';
import Questions from '../pages/questions/Questions';
import Choices from '../pages/choices/Choices';
import Questionnaire from '../pages/questionnaire/Questionnaire';
import Answers from '../pages/answers/Answers';
import Login from '../pages/auth/Login';
import About from '../pages/about/AboutUs';
import PrivacyPolicy from '../pages/about/PrivacyPolicy';
import PrivacyPolicyPublic from '../pages/about/PrivacyPolicyPublic';
import Slogans from '../pages/slogans/Slogans';
import Awards from '../pages/awards/Awards';

import { app } from '../db'

const router = new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard
        },
        {
            path: '/modules',
            name: 'modules',
            component: Modules
        },
        {
            path: '/questions',
            name: 'questions',
            component: Questions
        },
        {
            path: '/choices',
            name: 'choices',
            component: Choices
        },
        {
            path: '/questionnaire',
            name: 'questionnaire',
            component: Questionnaire
        },
        {
            path: '/answers',
            name: 'answers',
            component: Answers
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/privacy',
            name: 'privacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/privacy-policy',
            name: 'privacyPolicyPublic',
            component: PrivacyPolicyPublic
        },
        {
            path: '/slogans',
            name: 'slogans',
            component: Slogans
        },
        {
            path: '/awards',
            name: 'awards',
            component: Awards
        },

    ]
});

router.beforeEach((to, from, next) => {
    if (to.path !== '/' && to.path !== '/privacy-policy') {
        if (app.auth().currentUser)
            next()
        else
            next('/');

    }
    else {
        next();
    }
})
export default router;